import axios from 'axios';

// Production backend for native APK / iOS builds. This is the source of
// truth when REACT_APP_BACKEND_URL is missing at build time (the common
// failure mode for Capacitor APKs — relative paths resolve to
// https://localhost inside the WebView and never reach our backend).
const PRODUCTION_API_FALLBACK = 'https://business.becaim.app';

// Resolve the backend origin in this order:
//  1. Explicit absolute REACT_APP_BACKEND_URL baked in at build time → use it
//     (every yarn build script sets this, whether pointing at production or,
//     for `*:local-debug` scripts, at a local backend — native included).
//  2. Empty/missing/relative env → production fallback. This specifically
//     guards native builds that skipped the env var entirely: a relative
//     path would resolve to https://localhost inside the WebView and never
//     reach any backend.
function resolveBackendUrl() {
  const fromEnv = (process.env.REACT_APP_BACKEND_URL || '').trim();
  if (fromEnv && /^https?:\/\//i.test(fromEnv)) return fromEnv.replace(/\/+$/, '');
  return PRODUCTION_API_FALLBACK;
}

const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('gm_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname || '';
      // Only redirect to consumer /login when the user is already on a consumer
      // PRIVATE route. Public, marketing, and BecAIm Business routes must never
      // be hijacked by a consumer-side 401 (the business app has its own auth).
      const CONSUMER_PRIVATE = ['/app','/feed','/friends','/dm','/coach','/groups','/profile','/users','/goals','/onboarding','/setup-username','/notifications','/redeem','/future-me','/marketplace','/achievements','/invite','/challenges','/admin'];
      const isConsumerPrivate = CONSUMER_PRIVATE.some((p) => path === p || path.startsWith(p + '/'));
      if (isConsumerPrivate && !path.startsWith('/login')) {
        localStorage.removeItem('gm_token');
        localStorage.removeItem('gm_user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);
